const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 60 * 60 * 24 * 365],
  ['month', 60 * 60 * 24 * 30],
  ['week', 60 * 60 * 24 * 7],
  ['day', 60 * 60 * 24],
  ['hour', 60 * 60],
  ['minute', 60],
  ['second', 1],
];

const formatterCache = new Map<string | undefined, Intl.RelativeTimeFormat>();

function getFormatter(locale?: string) {
  if (!formatterCache.has(locale)) {
    try {
      formatterCache.set(locale, new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }));
    } catch {
      formatterCache.set(locale, new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }));
    }
  }
  return formatterCache.get(locale)!;
}

export function formatRelativeTime(isoDate: string | null | undefined, locale?: string): string {
  if (!isoDate) {
    return '';
  }
  const target = new Date(isoDate);
  if (Number.isNaN(target.getTime())) {
    return '';
  }

  const now = Date.now();
  const diffSeconds = Math.round((target.getTime() - now) / 1000);

  const formatter = getFormatter(locale);

  for (const [unit, unitSeconds] of UNITS) {
    const value = diffSeconds / unitSeconds;
    if (Math.abs(value) >= 1 || unit === 'second') {
      return formatter.format(Math.round(value), unit);
    }
  }

  return '';
}
